<template>
    <div class="ai-sales-assistant">
        <div class="container">
            <div class="header">
                <h1>AI销售助手</h1>
                <p>智能化销售解决方案，全面提升销售效率和成功率</p>
            </div>

            <div class="modules-grid">
                <!-- @click="openModal(key)" -->
                <div v-for="(module, key) in modules" :key="key" class="module-card" :class="key">
                    <div class="module-icon" :class="key">{{ module.icon }}</div>
                    <h3 class="module-title">{{ module.title }}</h3>
                    <p class="module-description">{{ module.description }}</p>
                    <ul class="feature-list">
                        <li v-for="feature in module.features" :key="feature.id"
                            :class="feature.enable ? 'feature-item-hover' : ''"
                            @click.stop="feature.enable && openFeatureDetail(module, feature.name, feature.id)">
                            <span>{{ feature.name }}</span>
                            <!-- <span v-if="!feature.enable" style="color:#bbb;font-size:0.95em;margin-left:8px;">（开发中）</span> -->
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 弹窗模态框 -->
        <div v-if="showModal" class="modal" @click="closeModal">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <span class="modal-title">{{ selectedModule.title }}</span>
                    <span class="close" @click="closeModal">&times;</span>
                </div>
                <div class="modal-body">
                    <div class="function-overview">
                        {{ selectedModule.overview }}
                    </div>

                    <div class="core-functions">
                        <h3>核心功能</h3>
                        <div class="function-grid">
                            <div v-for="func in selectedModule.functions" :key="func.name" class="function-item">
                                <div class="function-icon">{{ getFunctionIcon(func.name) }}</div>
                                <div class="function-content">
                                    <h4>{{ func.name }}</h4>
                                    <p>{{ func.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="core-advantage">
                        <h3>核心优势</h3>
                        <p>{{ selectedModule.advantage }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 功能详情弹窗 -->
        <!-- 点击弹窗外的区域关闭弹窗 -->
        <div v-if="showFeatureDetail" class="modal" @click="closeFeatureDetail">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <span class="modal-title">{{ featureDetailTitle }}</span>
                    <span class="close" @click="closeFeatureDetail">&times;</span>
                </div>
                <div class="modal-body">
                    <div v-if="chatWindows[featureDetailContent]">
                        <div class="industry-assistant-window">
                            <div class="assistant-header">
                                <div class="assistant-avatar" alt="助手头像"></div>
                                <div class="assistant-intro">{{ chatWindows[featureDetailContent].intro }}</div>
                            </div>
                            <div class="assistant-chat-area">
                                <div v-for="msg in chatWindows[featureDetailContent].messages" :key="msg.id"
                                    :class="['chat-msg', msg.role]">
                                    <div v-if="msg.role === 'assistant'" class="chat-avatar" alt="助手"></div>
                                    <div v-if="msg.role === 'user'" class="user-avatar" alt="用户"></div>
                                    <div class="chat-bubble">
                                        <div v-html="msg.content"></div>
                                        <div class="chat-time">{{ msg.time }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="assistant-input-area">
                                <div class="user-avatar" alt="用户"></div>
                                <input v-model="chatWindows[featureDetailContent].input"
                                    @keyup.enter="sendChatMsg(featureDetailContent)"
                                    :placeholder="chatWindows[featureDetailContent].placeholder"
                                    :disabled="chatWindows[featureDetailContent].isResponding"
                                    :class="{ 'disabled': chatWindows[featureDetailContent].isResponding }" />
                                <button v-if="!chatWindows[featureDetailContent].isResponding"
                                    @click="sendChatMsg(featureDetailContent)" class="send-btn">发送</button>
                                <button v-if="chatWindows[featureDetailContent].isResponding"
                                    @click="stopChatResponse(featureDetailContent)" class="stop-btn">停止回答</button>
                            </div>
                        </div>
                    </div>


                    <div v-else-if="featureDetailContent === 'market-3'">
                        <div class="zip-download-window" style="padding:32px 0;text-align:center;">
                            <div style="font-size:1.1em;margin-bottom:18px;color:#333;">
                                您可以下载客户信息挖掘的应用程序，在本地进行使用和测试。</div>
                            <a href="https://doeasyit.com/api/get_res_zip/search.zip" download
                                style="display:inline-block;padding:10px 32px;background:#1976d2;color:#fff;border-radius:8px;font-size:1.08em;font-weight:600;text-decoration:none;box-shadow:0 2px 8px rgba(52,152,219,0.08);transition:background 0.2s;">
                                点击下载 ZIP 文件
                            </a>
                            <div style="margin-top:10px;color:#888;font-size:0.98em;">（更多详情，敬请咨询。）
                            </div>
                        </div>
                    </div>

                    <div v-else-if="featureDetailContent === 'sales-2'">
                        <div class="promotion-material-container">
                            <!-- 左侧输入区域 -->
                            <div class="input-section">
                                <div class="input-header">
                                    <p class="input-description">输入企业相关信息，针对性地生成推广资料。</p>
                                </div>

                                <div class="input-content">
                                    <textarea v-model="promotionData.content" placeholder="请输入企业相关信息..."
                                        class="content-textarea" :disabled="promotionData.isGenerating">
                                    </textarea>

                                    <div class="button-container">
                                        <button @click="generatePromotionMaterial"
                                            :disabled="promotionData.isGenerating || !promotionData.content.trim()"
                                            class="generate-button"
                                            :class="{ 'disabled': promotionData.isGenerating || !promotionData.content.trim() }">
                                            {{ promotionData.isGenerating ? '生成中...' : '生成推广资料' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- 右侧PDF预览区域 -->
                            <div class="preview-section">
                                <h4 class="preview-title">预览：</h4>
                                <div class="pdf-container">
                                    <!-- 等待动画 -->
                                    <div v-if="promotionData.isGenerating" class="loading-container">
                                        <div class="loading-spinner"></div>
                                        <p class="loading-text">正在生成推广资料，请稍候...</p>
                                    </div>
                                    <!-- 错误提示 -->
                                    <div v-else-if="promotionData.errorMessage" class="error-container">
                                        <div class="error-icon">⚠️</div>
                                        <p class="error-text">{{ promotionData.errorMessage }}</p>
                                    </div>
                                    <!-- PDF预览 -->
                                    <iframe v-else-if="promotionData.pdfUrl" :src="promotionData.pdfUrl"
                                        class="pdf-iframe" frameborder="0">
                                    </iframe>
                                    <!-- 默认状态 -->
                                    <div v-else class="empty-preview">
                                        <div class="empty-icon">📄</div>
                                        <p class="empty-text">生成推广资料后将在此处显示预览</p>
                                    </div>
                                </div>
                                <div class="link-container">
                                    <a :href="promotionData.pdfUrl" target="_blank" class="open-pdf-link"
                                        :class="{ 'disabled': !promotionData.pdfUrl || promotionData.isGenerating }"
                                        :style="{ pointerEvents: (!promotionData.pdfUrl || promotionData.isGenerating) ? 'none' : 'auto' }">
                                        在新窗口中打开PDF
                                    </a>
                                    <a :href="promotionData.pdfUrl.replace('preview_pdf', 'download_file')" download
                                        class="download-pdf-link"
                                        :class="{ 'disabled': !promotionData.pdfUrl || promotionData.isGenerating }"
                                        :style="{ pointerEvents: (!promotionData.pdfUrl || promotionData.isGenerating) ? 'none' : 'auto' }">
                                        下载PDF文件
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>

        <!-- 行业信息搜索详情弹窗 -->
        <!-- <div v-if="showIndustryInfoDetail" class="modal" @click="closeIndustryInfoDetail">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <span class="modal-title">行业信息搜索详情</span>
            <span class="close" @click="closeIndustryInfoDetail">&times;</span>
          </div>
          <div class="modal-body">
            <p>这里是行业信息搜索的详细内容，您可以自定义展示内容。</p>
          </div>
        </div>
      </div> -->
    </div>
</template>

<script>
export default {
    name: 'AISalesAssistant',
    data() {
        return {
            showModal: false,
            selectedModuleKey: '',
            modules: {
                market: {
                    icon: '🎯',
                    title: '市场调研',
                    description: '智能搜索行业信息、企业信息等，快速获取有价值的市场情报和联系方式',
                    features: [
                        { id: 'market-1', name: '行业信息搜索', enable: true },
                        { id: 'market-2', name: '企业信息分析', enable: true },
                        { id: 'market-3', name: '客户信息挖掘', enable: true },
                        { id: 'market-4', name: '展会信息查询', enable: true }
                    ]
                },
                sales: {
                    icon: '📧',
                    title: '精准推销',
                    description: '精准推销，自动整理推广资料，通过多渠道进行智能化客户触达',
                    features: [
                        // { id: 'sales-1', name: '客户画像分析', enable: true },
                        { id: 'sales-2', name: '推广资料定制', enable: true },
                        { id: 'sales-3', name: '邮件营销', enable: true },
                        { id: 'sales-4', name: '短信推广', enable: true }
                    ]
                },
                materials: {
                    icon: '📚',
                    title: '资料管理',
                    description: '智能整理销售资料、产品资料、行业信息，建立知识库，提升信息利用效率',
                    features: [
                        { id: 'materials-1', name: '销售资料整理', enable: true },
                        { id: 'materials-2', name: '产品资料库', enable: true },
                        { id: 'materials-3', name: '行业信息汇总', enable: true },
                        { id: 'materials-4', name: '智能搜索', enable: true }
                    ]
                },
                promotion: {
                    icon: '📱',
                    title: '营销宣传',
                    description: 'AI生成公众号软文、视频号内容，自动化内容创作和发布，提升品牌曝光度',
                    features: [
                        { id: 'promotion-1', name: '公众号软文创作', enable: true },
                        { id: 'promotion-2', name: '视频内容编辑', enable: true },
                        { id: 'promotion-3', name: '内容发布管理', enable: true },
                        { id: 'promotion-4', name: '传播效果分析', enable: true }
                    ]
                },
                sop: {
                    icon: '⚙️',
                    title: '标准化流程',
                    description: '制定销售SOP标准操作指南，规范销售流程',
                    features: [
                        { id: 'sop-1', name: '客户开发流程', enable: true },
                        { id: 'sop-2', name: '需求挖掘方法', enable: true },
                        { id: 'sop-3', name: '产品推荐策略', enable: true },
                        { id: 'sop-4', name: '成交签单流程', enable: true },
                        // { id: 'sop-5', name: '流程监控优化', enable: true },
                        // { id: 'sop-6', name: '异议处理技巧', enable: true }
                    ]
                }
            },
            moduleData: {
                market: {
                    title: '市场调研',
                    overview: '智能搜索行业信息、客户信息、竞争对手信息等，快速获取有价值的市场情报和联系方式',
                    functions: [
                        {
                            name: '行业信息搜索',
                            description: '智能搜索行业动态、市场趋势、政策法规等信息，帮助销售人员快速了解市场环境'
                        },
                        {
                            name: '客户信息挖掘',
                            description: '快速挖掘潜在客户信息，包括企业基本信息、经营状况、联系方式等'
                        },
                        {
                            name: '竞争对手分析',
                            description: '收集竞争对手的产品信息、价格策略、市场份额等，为制定销售策略提供参考'
                        },
                        {
                            name: '供应链信息',
                            description: '分析客户上下游信息和供应商网络，识别商业机会和合作伙伴'
                        },
                        {
                            name: '供应商资源',
                            description: '整理优质供应商信息，建立供应商数据库，支持业务拓展和成本优化'
                        },
                        {
                            name: '展会信息查询',
                            description: '快速查询行业展会信息，包括时间、地点、参展商等，帮助把握商机'
                        }
                    ],
                    advantage: '基于大数据和AI算法的深度分析，确保获得最优质的市场信息和客户线索。'
                },
                sales: {
                    title: '精准推销',
                    overview: '基于客户画像进行精准推销，自动整理推广资料，通过多渠道进行智能化客户触达',
                    functions: [
                        {
                            name: '客户画像分析',
                            description: '基于客户数据构建详细画像，分析客户需求、偏好和购买行为，实现精准营销'
                        },
                        {
                            name: '推广资料定制',
                            description: '根据不同客户需求自动生成定制化推广资料，包括产品介绍、解决方案等'
                        },
                        {
                            name: '邮件营销',
                            description: '批量发送个性化邮件，优化邮件营销效果'
                        },
                        {
                            name: '短信推广',
                            description: '智能短信群发，支持个性化内容和定时发送，提高客户触达效率'
                        },
                        {
                            name: '电话营销支持',
                            description: '为销售人员提供话术建议和客户信息，提升电话营销成功率'
                        }
                    ],
                    advantage: '基于AI算法的精准客户匹配，实现个性化推销，大幅提升成交概率。'
                },
                materials: {
                    title: '资料管理',
                    overview: '智能整理和管理销售资料、产品资料、行业信息，建立知识库，提升信息利用效率',
                    functions: [
                        {
                            name: '销售资料整理',
                            description: '自动整理和分类销售相关资料'
                        },
                        {
                            name: '产品资料库',
                            description: '建立完整的产品资料库'
                        },
                        {
                            name: '行业信息汇总',
                            description: '收集整理行业报告、市场分析、竞品信息等行业资料'
                        },
                        {
                            name: '智能搜索',
                            description: '提供强大的搜索功能，快速找到所需资料，提高工作效率'
                        },
                        {
                            name: '知识库管理',
                            description: '建立企业知识库，沉淀经验和知识，便于团队学习和传承'
                        },
                        {
                            name: '版本控制',
                            description: '自动管理资料版本，确保团队使用最新版本，避免信息混乱'
                        }
                    ],
                    advantage: '智能化的资料管理系统，让销售人员能够快速找到所需资料，提升工作效率。'
                },
                promotion: {
                    title: '营销宣传',
                    overview: 'AI生成公众号软文、视频号内容，自动化内容创作和发布，提升品牌曝光度',
                    functions: [
                        {
                            name: '公众号软文创作',
                            description: 'AI智能生成高质量公众号文章，包括产品介绍、行业观点、案例分析等'
                        },
                        {
                            name: '视频内容编辑',
                            description: '视频号内容编辑，包括视频剪辑、字幕添加、特效处理等'
                        },
                        {
                            name: '内容发布管理',
                            description: '定时发布内容，管理发布计划，确保营销活动的连续性'
                        },
                        {
                            name: '传播效果分析',
                            description: '分析内容传播效果，监控阅读量、点赞数、转发数等关键指标'
                        }
                    ],
                    advantage: '结合AI创作能力，产出高质量的营销内容，大幅提升品牌曝光度。'
                },
                sop: {
                    title: '标准化流程',
                    overview: '制定销售SOP标准操作指南，规范销售流程，从客户开发到成交签单的全流程管理',
                    functions: [
                        {
                            name: '客户开发流程',
                            description: '标准化客户开发流程，从线索获取到初步接触的完整操作指南'
                        },
                        {
                            name: '需求挖掘方法',
                            description: '提供系统化的需求挖掘方法和工具，帮助销售人员深入了解客户需求'
                        },
                        {
                            name: '产品推荐策略',
                            description: '基于客户需求匹配最适合的产品解决方案，提高成交概率'
                        },
                        {
                            name: '异议处理技巧',
                            description: '整理常见客户异议及应对方法，提供标准化的异议处理流程'
                        },
                        {
                            name: '成交签单流程',
                            description: '规范成交签单流程，包括合同准备、价格谈判、签约等环节'
                        },
                        {
                            name: '流程监控优化',
                            description: '实时监控销售流程执行情况，分析瓶颈环节，持续优化流程'
                        }
                    ],
                    advantage: '基于最佳销售实践的标准化流程，确保每个销售人员都能按照最优方法工作，大幅提升团队整体表现。'
                }
            },
            showIndustryInfoDetail: false,
            showFeatureDetail: false,
            featureDetailTitle: '',
            featureDetailContent: '',
            // 1. data结构重构，统一用chatWindows对象管理所有对话窗口
            chatWindows: {
                'market-1': {
                    messages: [
                        { id: 1, role: 'assistant', content: '您好，我是行业信息搜索助手，请问有什么可以帮您？', time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
                    ],
                    input: '',
                    isResponding: false,
                    streamTimeout: null,
                    currentStreamResponse: null,
                    currentStreamReader: null,
                    // apiUrl: 'http://192.168.0.113/v1/chat-messages',
                    apiUrl: 'https://doeasyit.com/v1/chat-messages',
                    apiKey: 'app-cRyEXozbSq3b1uooTAt2IhgC',
                    formatAnswerContent: 'formatExpoContent',
                    intro: '您好！我是您的行业信息搜索助手，专注为您提供精准、全面的行业资讯和分析。请在下方输入您的问题或需求（如：“中国新能源汽车市场现状”），我会为您智能检索并解答。',
                    placeholder: '请输入您的的问题或需求...'
                },
                'market-2': {
                    messages: [
                        { id: 1, role: 'assistant', content: '您好，我是企业信息分析助手，请问有什么可以帮您？', time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
                    ],
                    input: '',
                    isResponding: false,
                    streamTimeout: null,
                    currentStreamResponse: null,
                    currentStreamReader: null,
                    // apiUrl: 'http://192.168.0.113/v1/chat-messages',
                    apiUrl: 'https://doeasyit.com/v1/chat-messages',
                    apiKey: 'app-eruvXoh74RxiGud7iVIPBFEz',
                    formatAnswerContent: 'formatExpoContent',
                    intro: '您好！我是您的企业信息分析助手，专注为您分析某家公司的产品技术细节、定价策略、市场竞争力等。请告诉我您想分析的公司名称（例如："华为"或"特斯拉"）。',
                    placeholder: '请输入您的的问题或需求...'
                },
                // 'market-3': {
                //     messages: [
                //         { id: 1, role: 'assistant', content: '您好，我是竞争对手分析助手，请问有什么可以帮您？', time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
                //     ],
                //     input: '',
                //     isResponding: false,
                //     streamTimeout: null,
                //     currentStreamResponse: null,
                //     currentStreamReader: null,
                //     apiUrl: 'http://192.168.0.113/v1/chat-messages',
                //     formatAnswerContent: 'formatExpoContent',
                //     intro: '您好！我是您的竞争对手分析助手，专注为您提供精准、全面的竞争对手分析。请在下方输入您的问题或需求，我会为您智能检索并解答。',
                //     placeholder: '请输入您的的问题或需求...'
                // },
                'market-4': {
                    messages: [
                        { id: 1, role: 'assistant', content: '您好，我是展会信息查询助手，请问有什么可以帮您？', time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }
                    ],
                    input: '',
                    isResponding: false,
                    streamTimeout: null,
                    currentStreamResponse: null,
                    currentStreamReader: null,
                    // apiUrl: 'http://192.168.0.113/v1/chat-messages',
                    apiUrl: 'https://doeasyit.com/v1/chat-messages',
                    apiKey: 'app-vM4eidtesKqIoEU11AJVK66b',
                    formatAnswerContent: 'formatExpoContent',
                    intro: '您好！我是您的展会信息查询助手，专注为您提供最新、最全的展会资讯。请在下方输入您的问题或需求（如：“近期视觉检测行业有哪些展会”），我会为您智能检索并解答。',
                    placeholder: '请输入您的的问题或需求...'
                },

                // 后续可继续扩展更多feature窗口
                // 
            },
            // 1. 在data()中添加推广资料定制相关数据
            promotionData: {
                content: '',
                isGenerating: false,
                pdfUrl: '',
                showPdf: false,
                errorMessage: ''
            },
        }
    },
    computed: {
        selectedModule() {
            return this.moduleData[this.selectedModuleKey] || {}
        }
    },
    methods: {
        getFunctionIcon(name) {
            const iconMap = {
                '行业信息搜索': '🔍',
                '客户信息挖掘': '👥',
                '竞争对手分析': '🏢',
                '供应链信息': '🔗',
                '供应商资源': '🏭',
                '展会信息查询': '📅',
                '客户画像分析': '🎯',
                '推广资料定制': '📝',
                '邮件营销': '📧',
                '短信推广': '📱',
                '电话营销支持': '📞',
                '销售资料整理': '📋',
                '产品资料库': '🛍️',
                '行业信息汇总': '📊',
                '智能搜索': '🔍',
                '知识库管理': '📚',
                '版本控制': '🔄',
                '公众号软文创作': '✍️',
                '视频内容编辑': '🎬',
                '内容发布管理': '📅',
                '传播效果分析': '📈',
                '客户开发流程': '🎯',
                '需求挖掘方法': '🔍',
                '产品推荐策略': '💡',
                '异议处理技巧': '❓',
                '成交签单流程': '✅',
                '流程监控优化': '📊'
            }
            return iconMap[name] || '📌'
        },
        openModal(moduleKey) {
            this.selectedModuleKey = moduleKey
            this.showModal = true
        },
        closeModal() {
            this.showModal = false
            this.selectedModuleKey = ''
        },
        openIndustryInfoDetail() {
            this.showIndustryInfoDetail = true
        },
        closeIndustryInfoDetail() {
            this.showIndustryInfoDetail = false
        },
        openFeatureDetail(module, featureName, featureId) {
            this.featureDetailTitle = featureName
            // 可根据featureId自定义内容
            // this.featureDetailContent = `${module.title} - ${featureName}（ID: ${featureId}）的详细内容，您可以自定义展示。`
            this.featureDetailContent = `${featureId}`
            this.showFeatureDetail = true

            let obj = document.getElementsByClassName("flex items-center gap-1")[0]
            if (obj) {
                obj.style.display = 'none'
            }

        },
        closeFeatureDetail() {
            this.showFeatureDetail = false
        },
        // 2. methods重构，所有对话窗口共用一套方法，传featureId区分
        sendChatMsg(featureId) {
            const win = this.chatWindows[featureId];
            const content = win.input.trim();
            if (!content || win.isResponding) return;
            const now = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            win.messages.push({ id: Date.now(), role: 'user', content, time: now });
            win.input = '';
            win.isResponding = true;
            this.$nextTick(() => this.scrollChatToBottom(featureId));
            const msgId = Date.now() + 1;
            const replyTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            win.messages.push({ id: msgId, role: 'assistant', content: '正在为您检索相关信息...', time: replyTime });
            this.startChatStream(featureId, content, msgId).catch(() => {
                const idx = win.messages.findIndex(msg => msg.id === msgId);
                if (idx !== -1) win.messages[idx].content = '抱歉，服务暂时不可用，请稍后重试。';
                win.isResponding = false;
            });
        },
        async startChatStream(featureId, query, messageId) {

            const win = this.chatWindows[featureId];
            // const apiKey = 'app-cRyEXozbSq3b1uooTAt2IhgC';
            const apiKey = win.apiKey;
            const url = win.apiUrl;
            const requestBody = {
                query: query,
                user: featureId,
                inputs: {},
                response_mode: 'streaming',
                conversation_id: '',
                files: []
            };
            try {
                win.streamTimeout = setTimeout(() => {
                    if (win.isResponding) this.handleChatTimeout(featureId, messageId);
                }, 20000);
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${apiKey}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                });
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                win.currentStreamResponse = response;
                const reader = response.body.getReader();
                win.currentStreamReader = reader;
                const decoder = new TextDecoder('utf-8');
                let buffer = '';
                while (true) {
                    const { done, value } = await reader.read();
                    // 重置超时定时器
                    if (win.streamTimeout) { clearTimeout(win.streamTimeout); win.streamTimeout = null; }
                    win.streamTimeout = setTimeout(() => {
                        if (win.isResponding) this.handleChatTimeout(featureId, messageId);
                    }, 20000);
                    if (done) break;
                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();
                    for (const line of lines) {
                        if (line.startsWith('data:')) {
                            let jsonStr = line.replace('data:', '').trim();
                            try {
                                const data = JSON.parse(jsonStr);
                                // console.log(data);
                                if (data.event === 'agent_message') {
                                    if (data.answer == ' ' || data.answer == '') continue;
                                    const idx = win.messages.findIndex(msg => msg.id === messageId);
                                    if (idx !== -1) {
                                        // let formattedAnswer = this[win.formatAnswerContent](data.answer || '');
                                        let formattedAnswer = data.answer || '';
                                        if (win.messages[idx].content === '正在为您检索相关信息...' || win.messages[idx].content.startsWith('正在搜索：')) {
                                            win.messages[idx].content = formattedAnswer;
                                        } else {
                                            // 累加内容
                                            win.messages[idx].content += formattedAnswer;
                                            win.messages[idx].content = this[win.formatAnswerContent](win.messages[idx].content);
                                        }
                                        this.$nextTick(() => this.scrollChatToBottom(featureId));
                                    }
                                } else if (data.event === 'agent_thought') {
                                    const idx = win.messages.findIndex(msg => msg.id === messageId);
                                    if (idx !== -1 && data.tool_input) {
                                        try {
                                            const toolData = JSON.parse(data.tool_input);
                                            console.log(toolData);
                                            // if (toolData.google_search && toolData.google_search.query) {
                                            //     win.messages[idx].content = `正在搜索：${toolData.google_search.query}...`;
                                            //     this.$nextTick(() => this.scrollChatToBottom(featureId));
                                            // }
                                            if (toolData.searxng_search && toolData.searxng_search.query) {
                                                win.messages[idx].content = `正在搜索： ${toolData.searxng_search.query} ... `;
                                                console.log(win.messages[idx].content);
                                                this.$nextTick(() => this.scrollChatToBottom(featureId));
                                            }
                                        } catch (e) { }
                                    }
                                } else if (data.event === 'message_end') {
                                    win.isResponding = false;
                                    win.currentStreamResponse = null;
                                    win.currentStreamReader = null;
                                }
                            } catch (e) { }
                        }
                    }
                }
                if (win.streamTimeout) { clearTimeout(win.streamTimeout); win.streamTimeout = null; }
                win.currentStreamReader = null;
                if (win.isResponding) { win.isResponding = false; win.currentStreamResponse = null; }
            } catch (error) {
                win.currentStreamReader = null;
                throw error;
            }
        },
        stopChatResponse(featureId) {
            const win = this.chatWindows[featureId];
            if (win.isResponding) {
                if (win.currentStreamReader) {
                    try { win.currentStreamReader.cancel(); } catch (e) { }
                    win.currentStreamReader = null;
                }
                win.currentStreamResponse = null;
                if (win.streamTimeout) { clearTimeout(win.streamTimeout); win.streamTimeout = null; }
                win.isResponding = false;
                const stopTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
                win.messages.push({ id: Date.now(), role: 'assistant', content: '已停止回答。您可以继续提问或重新开始对话。', time: stopTime });
                this.$nextTick(() => this.scrollChatToBottom(featureId));
            }
        },
        scrollChatToBottom(featureId) {
            // 只滚动当前窗口的聊天区
            this.$nextTick(() => {
                const chatArea = document.querySelectorAll('.assistant-chat-area');
                if (chatArea && chatArea.length) {
                    // 按featureId顺序渲染，取第几个
                    let idx = Object.keys(this.chatWindows).indexOf(featureId);
                    if (chatArea[idx]) chatArea[idx].scrollTop = chatArea[idx].scrollHeight;
                }
            });
        },
        handleChatTimeout(featureId, messageId) {
            const win = this.chatWindows[featureId];
            const idx = win.messages.findIndex(msg => msg.id === messageId);
            if (idx !== -1) {
                const content = win.messages[idx].content;
                if (content === '正在为您检索相关信息...' || content.startsWith('正在搜索：')) {
                    win.messages[idx].content = '抱歉，请求超时，请稍后重试。';
                }
            }
            win.isResponding = false;
            win.currentStreamResponse = null;
            win.currentStreamReader = null;
            if (win.streamTimeout) { clearTimeout(win.streamTimeout); win.streamTimeout = null; }

        },
        // 3. 各窗口自定义内容格式化方法
        formatMarket1Content(content) {
            if (!content) return '';
            let formatted = content;
            formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold;color: #000;">$1</span>');
            formatted = formatted.replace(/\n\-/g, '</br>&emsp;·');
            formatted = formatted.replace(/\n(\d+\.)/g, '</br>&emsp;$1');
            formatted = formatted.replace(/\n/g, '</br>');
            return formatted;
        },
        formatExpoContent(content) {
            if (!content) return '';
            let formatted = content;
            // 1. 加粗
            formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold;color: #000;">$1</span>');
            // 2. 列表项
            formatted = formatted.replace(/ \-/g, '&emsp;·');
            formatted = formatted.replace(/\- /g, '&emsp;·');
            // 3. 换行
            formatted = formatted.replace(/\n\n/g, '<br><br>&emsp;');
            formatted = formatted.replace(/\n/g, '<br>');
            formatted = formatted.replace(/#/g, '');
            // 4. 网址格式 [描述](url) => <a href="url" target="_blank">描述</a>
            formatted = formatted.replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
            return formatted;
        },
        // ...后续可继续扩展更多内容格式化方法
        // 2. 在methods中添加相关方法
        async generatePromotionMaterial() {
            if (!this.promotionData.content.trim() || this.promotionData.isGenerating) return;

            this.promotionData.isGenerating = true;

            try {
                const response = await fetch('https://doeasyit.com/v1/chat-messages', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer app-sAW8xQN9e2whyI7xduR141yu'
                    },
                    body: JSON.stringify({
                        query: this.promotionData.content,
                        user: 'promotion',
                        inputs: {},
                        response_mode: 'blocking',
                        conversation_id: '',
                        files: []
                    })
                });

                if (!response.ok) throw new Error('请求失败');

                const data = await response.json();
                if (data.answer) {
                    // 检查是否包含错误信息
                    if (data.answer.toLowerCase().includes('error')) {
                        this.promotionData.errorMessage = '服务器繁忙请重试';
                        this.promotionData.pdfUrl = '';
                        this.promotionData.showPdf = false;
                        return;
                    }
                    // 假设返回的是PDF链接
                    this.promotionData.pdfUrl = data.answer;
                    this.promotionData.showPdf = true;
                    this.promotionData.errorMessage = '';
                }
            } catch (error) {
                console.error('生成推广资料失败:', error);
                alert('生成失败，请稍后重试');
            } finally {
                this.promotionData.isGenerating = false;
            }
        },
    },
    mounted() {
        document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0
        // 监听ESC键关闭弹窗
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.showModal) {
                this.closeModal()
            }
        })
    },
    beforeDestroy() {
        // 组件销毁前清理定时器
        // 遍历所有聊天窗口，清理其定时器
        Object.values(this.chatWindows).forEach(win => {
            if (win.streamTimeout) {
                clearTimeout(win.streamTimeout);
                win.streamTimeout = null;
            }
            if (win.currentStreamReader) {
                try { win.currentStreamReader.cancel(); } catch (e) { }
                win.currentStreamReader = null;
            }
            if (win.currentStreamResponse) {
                win.currentStreamResponse.body?.cancel();
                win.currentStreamResponse = null;
            }
        });
    }
}
</script>

<style scoped>
.ai-sales-assistant {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    /* background: linear-gradient(135deg, #b2dfdb 0%, #80cbc4 50%, #4db6ac 100%); */
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    padding: 20px;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
}

.header {
    text-align: center;
    margin-bottom: 40px;
    color: rgb(0, 0, 0);
}

.header h1 {
    font-size: 2.5em;
    font-weight: 300;
    margin-bottom: 10px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header p {
    font-size: 1.2em;
    opacity: 0.9;
}

.modules-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-bottom: 40px;
}

.module-card {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 15px;
    padding: 25px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    backdrop-filter: blur(10px);
}

.module-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.module-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: white;
    font-weight: bold;
}

/* .module-icon.market { background: linear-gradient(135deg, #667eea, #764ba2); }
  .module-icon.sales { background: linear-gradient(135deg, #f093fb, #f5576c); }
  .module-icon.service { background: linear-gradient(135deg, #4facfe, #00f2fe); }
  .module-icon.materials { background: linear-gradient(135deg, #43e97b, #38f9d7); }
  .module-icon.promotion { background: linear-gradient(135deg, #fa709a, #fee140); } */
.module-icon.market {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.module-icon.sales {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.module-icon.service {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.module-icon.materials {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.module-icon.promotion {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}

.module-icon.sop {
    background: linear-gradient(135deg, #a8edea, #fed6e3);
}



.module-title {
    font-size: 1.5em;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.module-description {
    color: #666;
    line-height: 1.2;
    margin-bottom: 10px;
    height: 48px;
    /* 固定描述高度，确保所有功能列表从同一位置开始 */
    overflow: auto;
    height: 50px;
}

.feature-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.feature-list li {
    padding: 5px 0;
    color: #555;
    position: relative;
    padding-left: 20px;
}

.feature-list li:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #4CAF50;
    font-weight: bold;
}

.feature-item-hover {
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
}

.feature-item-hover:hover {
    background: #e3f2fd;
    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.10);
    transform: translateY(-2px) scale(1.03);
    color: #1976d2;
}

/* 修改弹窗样式 */
.modal {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background: #fff;
    padding: 0;
    border-radius: 12px;
    width: 90%;
    max-width: 1200px;
    max-height: 95vh;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    animation: modalSlideIn 0.3s ease;
    display: flex;
    flex-direction: column;
}

@keyframes modalSlideIn {
    from {
        transform: translateY(-50px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 20px 30px;
    border-radius: 12px 12px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-title {
    font-size: 1.5em;
    font-weight: 500;
    color: #333;
}

.close {
    color: #666;
    font-size: 24px;
    font-weight: normal;
    cursor: pointer;
    transition: opacity 0.3s ease;
    opacity: 0.8;
}

.close:hover {
    opacity: 1;
}

.modal-body {
    padding: 20px 30px;
    overflow-y: auto;
    flex: 1;
}

.function-overview {
    color: #666;
    margin-bottom: 15px;
    line-height: 1.8;
    font-size: 1.1em;
    text-align: center;
}

.core-functions {
    margin-bottom: 15px;
}

.core-functions h3 {
    color: #333;
    margin-bottom: 20px;
    font-size: 1.3em;
    text-align: center;
}

.function-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin: 0 auto;
}

.function-item {
    background: rgba(245, 247, 250, 0.8);
    padding: 20px;
    border-radius: 8px;
    border-left: 3px solid #c3cfe2;
    transition: all 0.3s ease;
    display: flex;
    align-items: flex-start;
}

.function-item:hover {
    background: rgba(195, 207, 226, 0.1);
    transform: translateY(-2px);
}

.function-icon {
    font-size: 1.2em;
    margin-right: 10px;
    color: #3498db;
    min-width: 24px;
    text-align: center;
}

.function-content {
    flex: 1;
}

.function-item h4 {
    color: #333;
    margin-bottom: 10px;
    font-size: 1.1em;
}

.function-item p {
    color: #666;
    font-size: 0.95em;
    line-height: 1.6;
}

.core-advantage {
    background: rgba(245, 247, 250, 0.8);
    padding: 25px;
    border-radius: 8px;
    margin-top: 30px;
    margin-bottom: 15px;
    border-left: 3px solid #c3cfe2;
}

.core-advantage h3 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.3em;
}

.core-advantage p {
    color: #666;
    line-height: 1.6;
}

.p-3 {
    display: none;
}

.industry-assistant-window {
    background: linear-gradient(135deg, #f5f7fa 0%, #e3ecf7 100%);
    border-radius: 20px;
    box-shadow: 0 4px 32px rgba(52, 152, 219, 0.10);
    max-width: 1100px;
    width: 95%;
    margin: 10px auto 0 auto;
    padding: 0 0 24px 0;
    display: flex;
    flex-direction: column;
    min-height: 640px;
}

.assistant-header {
    display: flex;
    align-items: center;
    padding: 28px 40px 10px 40px;
    border-bottom: 1px solid #e0e7ef;
    margin-bottom: 8px;
}

.assistant-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 16px;
    background: #f5f7fa;
    border: 2px solid #c3cfe2;
    background: url(../assets/img/ic_aislogo_choose_.png) no-repeat;
    background-size: 100% 100%;
}

.user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin: 0 10px;
    background: #f5f7fa;
    box-shadow: 0 1px 4px rgba(52, 152, 219, 0.08);
    background: url(../assets/img/new_ic_1.png) no-repeat;
    background-size: 100% 100%;
}

.assistant-intro {
    color: #555;
    font-size: 1.08em;
    flex: 1;
    line-height: 1.6;
}

.assistant-chat-area {
    flex: 1;
    padding: 0 15px;
    overflow-y: auto;
    margin-bottom: 16px;
    max-height: 440px;
    min-height: 180px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.04);
}

.chat-msg {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    margin-top: 15px;
    min-height: 40px;
}

.chat-msg.assistant {
    flex-direction: row;
}

.chat-msg.user {
    flex-direction: row-reverse;
}

.chat-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    margin: 8px 12px;
    background: #f5f7fa;
    box-shadow: 0 1px 4px rgba(52, 152, 219, 0.08);
    background: url(../assets/img/ic_aislogo_choose_.png) no-repeat;
    background-size: 100% 100%;
    flex-shrink: 0;
}

.user-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin: 0 12px;
    background: #f5f7fa;
    box-shadow: 0 1px 4px rgba(52, 152, 219, 0.08);
    background: url(../assets/img/new_ic_1.png) no-repeat;
    background-size: 100% 100%;
    flex-shrink: 0;
}

.chat-bubble {
    background: #e8f4fd;
    border-radius: 16px;
    padding: 12px 16px 28px 16px;
    color: #2c3e50;
    max-width: 75%;
    min-width: 80px;
    font-size: 1.08em;
    word-break: break-word;
    box-shadow: 0 3px 12px rgba(52, 152, 219, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1);
    position: relative;
    line-height: 1.7;
    margin-top: 2px;
    border: 1px solid #d1e7f0;
    text-align: left;
}

.chat-msg.user .chat-bubble {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
    box-shadow: 0 3px 12px rgba(40, 167, 69, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1);
}

.chat-bubble .chat-time {
    position: absolute;
    right: 12px;
    bottom: 6px;
    font-size: 0.8em;
    color: #6c757d;
    letter-spacing: 0.5px;
}

.assistant-input-area {
    display: flex;
    align-items: center;
    padding: 0 40px;
    margin-top: 12px;
}

.assistant-input-area .user-avatar {
    margin: 0 12px 0 0;
}

.assistant-input-area input {
    flex: 1;
    border: 1.5px solid #c3cfe2;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 1.08em;
    outline: none;
    margin-right: 12px;
    background: #fafdff;
    transition: border 0.2s;
}

.assistant-input-area input:focus {
    border: 1.5px solid #1976d2;
}

.assistant-input-area .send-btn {
    background: linear-gradient(135deg, #1976d2 0%, #48a9f8 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 28px;
    font-size: 1.08em;
    cursor: pointer;
    transition: background 0.2s;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(52, 152, 219, 0.08);
}

.assistant-input-area .send-btn:hover {
    background: linear-gradient(135deg, #125ea7 0%, #1976d2 100%);
}

.assistant-input-area .stop-btn {
    background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 28px;
    font-size: 1.08em;
    cursor: pointer;
    transition: background 0.2s;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.08);
}

.assistant-input-area .stop-btn:hover {
    background: linear-gradient(135deg, #c82333 0%, #dc3545 100%);
}

.assistant-input-area input.disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
    color: #888;
}

@media (max-width: 768px) {
    .modules-grid {
        grid-template-columns: 1fr;
    }

    .modal-content {
        width: 95%;
        max-height: 95vh;
    }

    .modal-body {
        padding: 20px;
    }

    .function-grid {
        grid-template-columns: 1fr;
    }
}

/* 修复链接样式作用范围，提升优先级 */
::v-deep .chat-bubble a {
    color: #1976d2 !important;
    text-decoration: underline !important;
    font-weight: bold !important;
    word-break: break-all !important;
}

/* 推广资料定制页面样式 */
.promotion-material-container {
    display: flex;
    height: 600px;
    gap: 20px;
}

.input-section {
    /* flex: 1; */
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
}

.input-header {
    margin-bottom: 20px;
}

.input-description {
    color: #666;
    font-size: 0.95em;
    margin: 0;


}

.input-content {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.content-textarea {
    flex: 1;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    resize: none;
    /* margin-bottom: 20px; */
    font-family: inherit;
}

.content-textarea:focus {
    outline: none;
    border-color: #1976d2;
}

.button-container {
    margin-top: 10px;
    text-align: center;
}

.generate-button {
    padding: 12px 32px;
    background: #1976d2;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.3s ease;
}

.generate-button:hover:not(.disabled) {
    background: #1565c0;
}

.generate-button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.preview-section {
    flex: 2;
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
}

.preview-title {
    color: #666;
    font-size: 0.95em;
    margin-bottom: 15px;
    margin-top: 0;
}

.pdf-container {
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: white;
    overflow: hidden;
}

.pdf-iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.link-container {
    margin-top: 10px;
    text-align: center;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.open-pdf-link {
    display: inline-block;
    padding: 12px 32px;
    background: #1976d2;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.3s ease;
}

.open-pdf-link:hover {
    background: #1565c0;
}

.open-pdf-link.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: #ccc;
}

.open-pdf-link.disabled:hover {
    background: #ccc;
}

.download-pdf-link {
    display: inline-block;
    padding: 12px 32px;
    background: #28a745;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.3s ease;
}

.download-pdf-link:hover {
    background: #218838;
}

.download-pdf-link.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: #ccc;
}

.download-pdf-link.disabled:hover {
    background: #ccc;
}

/* 等待动画样式 */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #666;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #1976d2;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-text {
    font-size: 14px;
    color: #666;
    margin: 0;
    text-align: center;
}

/* 空状态样式 */
.empty-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
}

.empty-text {
    font-size: 14px;
    margin: 0;
    text-align: center;
    line-height: 1.5;
}

/* 错误提示样式 */
.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #d32f2f;
}

.error-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.8;
}

.error-text {
    font-size: 14px;
    margin: 0;
    text-align: center;
    line-height: 1.5;
    color: #d32f2f;

}
</style>